// extracted by mini-css-extract-plugin
export default {"link":"social-share_link_fvV7u"};